export default "__VITE_ASSET__D$rVMlgd__"